import { useComponentNavigation } from "@organisms/ComponentNavigation/ComponentNavigation.context"

import styles from "./AuthDivider.module.scss"

export default function AuthDivider() {
    const { currentComponentId } = useComponentNavigation()
    const isOnOTPSlide = currentComponentId?.endsWith("_otp")

    return isOnOTPSlide ? null : (
        <div className={styles.base}>
            <div className={styles.line} />
            Or
            <div className={styles.line} />
        </div>
    )
}
